<template>
  <div class="index-container">
    <!-- 导航栏 -->
    <header class="header">
      <div class="container">
        <div class="logo">
          <div class="logo-inner">
            <div class="logo-icon">
              <div class="logo-circle"></div>
              <div class="logo-cross"></div>
            </div>
            <h1>阳煦信息咨询<span class="logo-highlight"></span></h1>
          </div>
        </div>
        <nav class="nav">
          <el-menu
            mode="horizontal"
            class="nav-menu"
            active-text-color="#1890ff"
            text-color="#333">
            <el-menu-item index="1"
              ><router-link to="/">首页</router-link></el-menu-item
            >
            <el-menu-item index="2">
              <router-link to="/products">产品服务</router-link>
            </el-menu-item>
            <el-menu-item index="3">
              <router-link to="/cases">客户案例</router-link>
            </el-menu-item>
            <el-menu-item index="4">
              <router-link to="/member">会员中心</router-link>
            </el-menu-item>
            <el-menu-item index="5">
              <router-link to="/about">关于我们</router-link>
            </el-menu-item>
          </el-menu>
        </nav>
      </div>
    </header>

    <!-- 内容区域 -->
    <main class="main-area">
      <router-view />
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-left">
            <h3>阳煦信息咨询</h3>
            <p>地址：北京市朝阳区三里屯时间国际A座</p>
            <p>电话：010-00000000</p>
            <p>邮箱：support@modao.cc</p>
            <div class="social-icons">
              <i class="el-icon-wechat"></i>
              <i class="el-icon-weibo"></i>
              <i class="el-icon-message"></i>
              <i class="el-icon-share"></i>
            </div>
          </div>
          <div class="footer-middle">
            <h4>企业介绍</h4>
            <ul>
              <li><a href="#">品牌介绍</a></li>
              <li><a href="#">团队介绍</a></li>
              <li><a href="#">关于我们</a></li>
            </ul>
          </div>
          <div class="footer-right">
            <h4>服务范围</h4>
            <ul>
              <li><a href="#">产品介绍</a></li>
              <li><a href="#">新闻动态</a></li>
              <li><a href="#">服务优势</a></li>
            </ul>
          </div>
        </div>
        <div class="footer-bottom">
          <p>友情链接：百度 | 新浪 | 网易</p>
          <p>
            &copy; {{ new Date().getFullYear() }} 企业服务官网模板.
            保留所有权利。
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Index",
  components: {},
  data() {
    return {
      appName: "阳煦信息咨询",
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
@import "index.less";
.el-menu--horizontal > .el-menu-item a,
.el-menu--horizontal > .el-menu-item a:hover {
  color: inherit;
  text-decoration: none;
}
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.header {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
  }
  .logo {
    .logo-inner {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .logo-icon {
      position: relative;
      width: 44px;
      height: 44px;

      .logo-circle {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 12px;
        background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
        transform: rotate(15deg);
      }

      .logo-cross {
        position: absolute;
        width: 8px;
        height: 32px;
        background-color: white;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      .logo-cross::after {
        content: "";
        position: absolute;
        width: 8px;
        height: 32px;
        background-color: white;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) rotate(-90deg);
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    }

    h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 700;
      color: #333;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -8px;
        width: 0;
        height: 3px;
        background: linear-gradient(90deg, #1890ff 0%, #36cfc9 100%);
        transition: width 0.3s ease;
      }

      &:hover::after {
        width: 100%;
      }
    }

    .logo-highlight {
      color: #1890ff;
      font-weight: 800;
    }
  }
  .nav-menu {
    border: none;
    font-weight: 600;
    font-size: 16px;
    padding: 0;

    .el-menu-item {
      font-size: 16px;
      padding: 0 20px;
      height: 80px;
      line-height: 80px;
      transition: all 0.3s ease;
      margin: 0;

      &:hover {
        background-color: #f0f8ff;
        color: #1890ff;
        transform: translateY(-2px);
      }

      &.is-active {
        font-weight: 700;
        color: #1890ff;
        background-color: #f0f8ff;
      }
    }
  }
}

.main-area {
  min-height: calc(100vh - 160px);
  padding: 40px 0;
}

.footer {
  background-color: #f5f5f5;
  padding: 40px 0;
  margin-top: 60px;
  .footer-content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    .footer-left {
      width: 40%;
      h3 {
        margin-top: 0;
        margin-bottom: 20px;
        font-size: 18px;
        color: #333;
      }
      p {
        margin-bottom: 12px;
        color: #666;
        line-height: 1.6;
      }
      .social-icons {
        margin-top: 20px;
        i {
          font-size: 20px;
          margin-right: 15px;
          color: #666;
          cursor: pointer;
          &:hover {
            color: #1890ff;
          }
        }
      }
    }
    .footer-middle,
    .footer-right {
      width: 25%;
      h4 {
        margin-top: 0;
        margin-bottom: 20px;
        font-size: 16px;
        color: #333;
      }
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
          margin-bottom: 10px;
          a {
            color: #666;
            text-decoration: none;
            &:hover {
              color: #1890ff;
            }
          }
        }
      }
    }
  }
  .footer-bottom {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #e8e8e8;
    p {
      margin-bottom: 10px;
      color: #999;
      font-size: 14px;
    }
  }
}
</style>
